import { Entity, type EntityProps } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

export enum AssumptionValidated {
    NO = 'NO',
    NO_CREATE_TASK = 'NO_CREATE_TASK',
    VALIDATION_PENDING = 'VALIDATION_PENDING',
    YES = 'YES',
}

export const assumptionValidatedMap: Record<AssumptionValidated, string> = {
    [AssumptionValidated.NO]: 'No',
    [AssumptionValidated.NO_CREATE_TASK]: 'No (task not created)',
    [AssumptionValidated.VALIDATION_PENDING]: 'Validation pending',
    [AssumptionValidated.YES]: 'Yes',
};

export interface AssumptionProps extends EntityProps {
    description: string;
    responsibleId: string;
    validated: AssumptionValidated;
    validationDate?: Date;
    taskRef?: string;
    taskUpdated?: string;
}

export class Assumption extends Entity implements AssumptionProps {
    description: string;
    responsibleId: string;
    validated: AssumptionValidated;
    validationDate?: Date;
    taskRef?: string;
    taskUpdated?: string;

    constructor({
        id,
        name,
        description,
        responsibleId,
        validationDate,
        validated,
        taskRef,
        taskUpdated,
    }: AssumptionProps) {
        super({ id, name });
        this.description = description;
        this.responsibleId = responsibleId;
        this.validated = validated;
        this.validationDate = validationDate;
        this.taskRef = taskRef;
        this.taskUpdated = taskUpdated;

        if (
            this.validated === AssumptionValidated.NO_CREATE_TASK &&
            !this.validationDate
        ) {
            throw new Error(
                'Assumption with NO_CREATE_TASK validation must have a validation date.',
            );
        }
    }

    static new(props: Omit<Omit<AssumptionProps, 'id'>, 'files'>): Assumption {
        return new Assumption({
            id: new UUID().toString(),
            ...props,
        });
    }
}
